module.exports = __webpack_public_path__ + "img/2.3a44f528.jpg";